import type { ReactNode } from 'react'
import { cn } from '../utils/cn'

export function DrawerReadonlyValue({
  multiline,
  children,
  className,
}: {
  multiline?: boolean
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'min-w-0 py-0.5 text-sm font-medium leading-6 text-aera-charcoal',
        multiline && 'whitespace-pre-wrap wrap-break-word',
        className,
      )}
    >
      {children}
    </div>
  )
}

export function DrawerFieldShell({
  multiline,
  interactive,
  editable,
  children,
  className,
}: {
  multiline?: boolean
  interactive?: boolean
  editable?: boolean
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'relative w-full rounded-lg border border-aera-lightgray/80 bg-aera-white px-3 py-2 text-sm shadow-[0_1px_2px_rgba(0,0,0,0.02)] transition-colors',
        multiline ? 'min-h-[96px] block' : 'min-h-[40px] flex items-center',
        interactive &&
          'cursor-pointer hover:border-aera-charcoal/15 hover:bg-aera-lightgray/25',
        editable &&
          'focus-within:border-aera-amber focus-within:ring-2 focus-within:ring-aera-amber/20',
        className,
      )}
    >
      {children}
    </div>
  )
}
